<template>
    <el-upload
      :action="uploadFileApi"
      ref="uploadFile"
      :headers="headers"
      :multiple="multiple"
      :name="name"
      :show-file-list="showFileList"
      :drag="drag"
      :accept="accept"
      :list-type="listType"
      :auto-upload="autoUpload"
      :disabled="disabled"
      :limit="limit"
      :file-list="fileList"

      :on-preview="previewHandle"
      :on-remove="removeHandle"
      :before-remove="beforeRemoveHandle"
      :on-success="successHandle"
      :on-error="errorHandle"
      :on-progress="progressHandle"
      :before-upload="beforeUploadHandle"
      :on-exceed="exceedHandle"
    >
        <!-- 触发文件选择框的内容 -->
      <slot name="trigger"></slot>
      <!-- 提示说明文字 -->
      <slot name="tip"></slot>
      <!-- 预览 -->
      <!-- <el-dialog :visible.sync="previewShow" append-to-body>
        <img width="100%" :src="previewUrl" alt="">
      </el-dialog> -->
      <el-image-viewer
          :zIndex="9999"
          v-if="previewShow"
          :on-close="closeImgViewer"
          :url-list="previewUrl" />
    </el-upload>

</template>

<script>
import { loadAutoToken} from '@/jslib/cache'
import { mapGetters } from 'vuex'
import {downloadFileByUrl,openIframe} from '@/jslib/utils'
export default {
  components: {
    'ElImageViewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  props: {
    /** 绑定值，格式为 /file/xx/xx.jpg 多个文件逗号隔开 */
    value: {
        type: Array,
        default: () => []
      },
      /** 是否支持多选文件 */
      multiple: {
        type: Boolean,
        required: false,
        default: true
      },
      /** 上传时附带的额外参数 */
      data: {
        type: Object,
        required: false
      },
      /** 上传的文件字段名 */
      name: {
        type: String,
        required: false
      },
      /** 是否显示已上传文件列表 */
      showFileList: {
        type: Boolean,
        required: false,
        default: true
      },
      /** 是否启用拖拽上传 */
      drag: {
        type: Boolean,
        required: false,
        default: false
      },
      /** 接受上传的文件类型 */
      accept: {
        type: String,
        required: false
      },
      /** 文件列表的类型 可选值：text/picture/picture-card */
      listType: {
        type: String,
        required: false
      },
      /** 是否在选取文件后立即进行上传 */
      autoUpload: {
        type: Boolean,
        required: false,
        default: true
      },
      /** 是否禁用 */
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      /** 最大允许上传个数 */
      limit: {
        type: Number,
        required: false,
        default: 20
      },
      /** 文件大小限制：单位MB */
      sizeLimit: {
        type: Number,
        required: false,
        default: 100
      },
      /** 是否禁用删除: 默认不禁用 */
      delEnable: {
        type: Boolean,
        required: false,
        default: true
      }
  },
  data() {
    return {
      headers: {
        'usertoken': loadAutoToken()
      },
      temps: [],
        files: [],

        previewShow: false,
        previewUrl: [],

        ts: []
    }
  },
  computed: {

    ...mapGetters([
      'uploadFileApi'
    ]),
    fileList() {
        this.temps.splice(0,this.temps.length)
        // if (this.value){
        //   this.value.split(',').forEach(item => {
        //     this.temps.push(item)
        //   })
        // }
        if (this.value){
          this.value.forEach(item => {
            this.temps.push(item)
          })
        }
        if (this.temps.length > 0){
          // this.files.filter(item => !this.temps.includes(item.response.link)).forEach(item => {
          //   this.files.splice(this.files.indexOf(item),1)
          // })
          this.files = this.temps.map(item => {
            return {
              name: item.fileName,
              url: item.url,
              using: true,
              response: {
                link: item.url
              }
            }
          })
          // let links = this.files.map(item => {return item.response.link})
          // this.temps.forEach(item => {
          //   if (!links.includes(item)){
          //     this.files.push({
          //       name: item.substring(item.lastIndexOf('/') + 1,item.length),
          //       url: item,
          //       using: true,
          //       response: {
          //         link: item
          //       }
          //     })
          //   }
          // })
        }else{
          this.files.splice(0,this.files.length)
        }
        return this.files
      }
  },
  methods: {
    closeImgViewer() {
      this.previewShow = false
    },
    /** 点击文件列表中已上传的文件时的钩子 */
    previewHandle(){
        let link = arguments[0].response.link
        let s_1 = link.lastIndexOf('/') + 1
        let s_2 = link.lastIndexOf('.')
        let ext = link.substring(s_2 + 1,link.length)
        let fileName = link.substring(s_1,s_2)
        if (['png', 'jpg', 'jpeg', 'gif'].indexOf(ext.toLowerCase()) === -1){
          // 非图片类型，下载
          // downloadFileByUrl(link, fileName, ext)
          openIframe(link)
        }else{
          this.previewShow = true
          this.previewUrl =  [link]
        }
      },
      /** 删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。 */
      beforeRemoveHandle(file, fileList) {
        return this.delEnable
      },
      /** 文件列表移除文件时的钩子 */
      removeHandle(file, fileList) {
        // this.temps.splice(this.temps.findIndex(item => item === file.response.link),1)
        let t = []
        fileList.forEach(item => {
          let u = item.response.link || ''
          if (!!t){
            t.push({
              url: u,
              fileName: item.name
            })
          }else{
            t = [{
              url: u,
              fileName: item.name
            }]
          }
          item.url = item.response.link
          item.using = true
        })
        this.$emit('input', t)
        this.$emit('change')
      },
      /** 文件上传成功时的钩子 */
      successHandle(response, file, fileList) {
        console.log(response,file,fileList)
        if (!!response.link){
          // this.ts.push(response.link)
          if (fileList.every(item => item.status === 'success')){
            // let t = this.value
            // fileList.filter(item => !item.using).forEach(item => {
            //   let u = item.response.link || ''
            //   if (!!t){
            //     t += ',' + u
            //   }else{
            //     t = u
            //   }
            //   item.url =  item.response.link
            //   item.using = true
            //   this.files.push(item)
            // })
            // this.ts.splice(0, this.ts.length)
            // this.$emit('input', t)
            // let t = this.value
            let  t =[]
            fileList.forEach(item => {
              let u = item.response.link || ''
              if (!!t){
                t.push({
                  url: u,
                  fileName: item.name
                })
              }else{
                t = [{
                  url: u,
                  fileName: item.name
                }]
              }
              item.url = item.response.link
              item.using = true
              this.files.push(item)
            })
            // this.ts.splice(0, this.ts.length)
            console.log('input',t)
            this.$emit('input', t)
            this.$emit('change')
          }
        }
      },
      /** 文件上传失败时的钩子 */
      errorHandle(e, file, fileList){
        const msg = JSON.parse(e.message)
        this.$notify({
          title: msg.message,
          type: 'error',
          duration: 2500
        })
      },
      /** 文件上传时的钩子 */
      progressHandle(event, file, fileList){

      },
      /** 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。 */
      beforeUploadHandle(file) {
        const isLtM = file.size / 1024 / 1024 < this.sizeLimit
        if (!isLtM) {
          this.$message.error('上传文件大小不能超过 ' + this.sizeLimit + 'MB!')
        }
        return isLtM
      },
      /** 文件超出个数限制时的钩子 */
      exceedHandle(files, fileList){
        this.$message.warning(`文件个数不能超出${this.limit}个`)
      }
  }
}
</script>

<style scoped>
  .pic-uploader-component .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .pic-uploader-component .el-upload .pic-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .pic-uploader-component .el-upload .pic {
    width: 178px;
    height: 178px;
    display: block;
  }

  .pic-uploader-component .el-upload:hover {
    border-color: #409EFF;
  }

</style>
